import * as React from 'react';

import { ContentCard } from '@rematter/ui-web';

import { CategoryFormState } from '../../../_state/categoryForm.state';
import { CategoryRecord } from '../../../types/inventoryItem';

import { CategoryDetailsForm } from './CategoryDetailsForm';
import { CategoryFormFooterActions } from './CategoryFormFooterActions';

type Props = {
  category?: CategoryRecord | null;
  onDiscard?: () => void;
  onSaveUpdates?: (data?: CategoryFormState) => void;
  isSaving?: boolean;
};

export const CategoryTabDetails: React.FC<Props> = ({
  category,
  onDiscard,
  onSaveUpdates,
  isSaving = false,
}) => (
  <div className="@CategoryTabDetails flex max-h-full flex-col gap-5 p-5">
    <ContentCard className="p-0 pt-5">
      <CategoryDetailsForm category={category} disabled={false} />
      <CategoryFormFooterActions
        onSaveUpdates={onSaveUpdates}
        onDiscard={onDiscard}
        isSaving={isSaving}
      />
    </ContentCard>
  </div>
);
